import React, { useState, useEffect } from 'react'
import { Container, Form, Button, Row, Col } from 'react-bootstrap';
import {  useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import { useProfileMutation } from '../../slices/students/studentsApiSlice';
import { setStudentCredentials } from '../../slices/students/authStudentSlice';
import { toast } from 'react-toastify';
import Loader from '../../components/Loader';
import Message from '../../components/Message';
import StudentHeader from '../../components/StudentHeader';
import StudentNavbar from '../../components/StudentNavbar';

const StudentProfile = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [email, setEmail] = useState('');
  const [city, setCity] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [country, setCountry] = useState('United States');


  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
    
  const { studentInfo } = useSelector((state) => state.authStudent);

  const [updateProfile, { isLoading: loadingUpdateProfile }] = useProfileMutation();

  useEffect(() => {
    if(!studentInfo) {
        navigate('/studentlogin')
    }   
}, [navigate, studentInfo])

  useEffect(() => {
    setFirstname(studentInfo?.firstname);
    setLastname(studentInfo?.lastname);
    setEmail(studentInfo?.email);
    setCity(studentInfo?.city);
    setZipcode(studentInfo?.zipcode);
    setCountry(studentInfo?.country);
  }, [studentInfo?.firstname, studentInfo?.lastname, studentInfo?.email]);

  const submitHandler = async (e) => {
    e.preventDefault()
    if (firstname == '') { toast.error('Please enter a first name'); return; } 
    if (lastname == '') { toast.error('Please enter a last name'); return; } 
    if (email == '') { toast.error('Please enter a email'); return; } 
    if (city == '') { toast.error('Please enter a city'); return; } 
    if (zipcode == '') { toast.error('Please enter a zip code'); return; } 
    if (country == '') { toast.error('Please enter a country'); return; } 

    if (password !== confirmPassword) {
      toast.error('Passwords do not match');
    }
    else {
      try {
        const res = await updateProfile({ firstname, lastname, email, city, zipcode, country, password }).unwrap();
        dispatch(setStudentCredentials({ ...res }));
        toast.success('Profile Updated');
      } catch (err) {
        toast.error(err?.data?.message || err.error.message);
      }
    };
  };

  return (
    <div>
    <StudentNavbar />
      <div className="main-content" id="panel">
        <StudentHeader />
        <br /><br /><br /><br /><br />
        <div className="container-fluid mt--6 ">
            <div className="row ">
              <div className="col-xl-8 offset-xl-2 ">  
                <div className="card-wrapper profileCard">
                  <div className="card profileCard2"> <br />
                    <h2 className="centerTitle tittleColor4 ">
                      <span className='tittleColor4'>
                      Student Profile
                      </span>
                      </h2><br />
                  <div className="card-body ">
                <Form onSubmit={submitHandler} >
                  <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative mb-3">
                      <div className="input-group-prepend moveInput">
                        <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                      </div>
                      <input 
                        className="form-control " 
                        placeholder="First Name" 
                        value={firstname}
                        onChange={(e) => setFirstname(e.target.value)}
                        type="text"                       
                      />
                    </div>
                  </div>
                  <br />
                  <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative mb-3">
                      <div className="input-group-prepend moveInput">
                        <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                      </div>
                      <input 
                        className="form-control" 
                        placeholder="Last Name" 
                        value={lastname}
                        onChange={(e) => setLastname(e.target.value)}
                        type="text"                       
                      />
                    </div>
                  </div>
                  <br />
                  <div className="form-group mb-3">
                    <div className="input-group input-group-merge input-group-alternative">
                      <div className="input-group-prepend moveInput">
                        <span className="input-group-text bg-gradient-danger"><i className="ni ni-email-83 navText"></i></span>
                      </div>
                      <input 
                        className="form-control" 
                        placeholder=" Email" 
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        type="email"                         
                      />
                    </div>
                  </div>
                  <br />

                  <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative mb-3">
                      <div className="input-group-prepend moveInput">
                        <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                      </div>
                      <input 
                        className="form-control" 
                        placeholder="Country" 
                        value={country}
                        onChange={(e) => setCountry(e.target.value)}
                        type="text"                       
                      />
                    </div>
                  </div>
                  <br />

                  <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative mb-3">
                      <div className="input-group-prepend moveInput">
                        <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                      </div>
                      <input 
                        className="form-control" 
                        placeholder="City" 
                        value={city}
                        onChange={(e) => setCity(e.target.value)}
                        type="text"                       
                      />
                    </div>
                  </div>
                  <br />

                  <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative mb-3">
                      <div className="input-group-prepend moveInput">
                        <span className="input-group-text bg-gradient-info"><i className="ni ni-tag navText"></i></span>
                      </div>
                      <input 
                        className="form-control" 
                        placeholder="Zip Code" 
                        value={zipcode}
                        onChange={(e) => setZipcode(e.target.value)}
                        type="text"                       
                      />
                    </div>
                  </div>
                  <br />



                  <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative">
                      <div className="input-group-prepend moveInput">
                        <span className="input-group-text bg-gradient-warning"><i className="ni ni-lock-circle-open navText"></i></span>
                      </div>
                      <input 
                        className="form-control" 
                        placeholder=" Password" 
                        type="password"    
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}                      
                      />
                    </div>
                  </div>
                  <br />
                  <div className="form-group">
                    <div className="input-group input-group-merge input-group-alternative">
                      <div className="input-group-prepend moveInput">
                        <span className="input-group-text bg-gradient-primary"><i className="ni ni-lock-circle-open navText"></i></span>
                      </div>
                      <input 
                        className="form-control" 
                        placeholder=" Confirm Password" 
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        type="password"                          
                      />
                    </div>
                  </div><br /><br />
                  <Button type='submit' variant='success' className=' btn btn-primary btn-lg rounded-pill bg-gradient-primary profileBtn'>
                    Update
                  </Button><br />
                  {loadingUpdateProfile && <Loader />}
                </Form>
                </div>
                </div>
                </div>
            </div>
          </div>
        </div>
      </div>  
    </div>
  )
}

export default StudentProfile